import request from '@/utils/request'

/**
 * 获取所有用户信息
 */
export const getUserList = (page, limit, keyword) => {
  return request({
    url: '/admin/users',
    method: 'GET',
    params: { page, limit, keyword }
  })
}

/**
 * 获取用户详情
 */
export const getUserDetail = (userId) => {
  return request({
    url: `/admin/user/${userId}`,
    method: 'GET'
  })
}

/**
 * 获取用户正在进行的服务
 */
export const getUserOngoingServices = () => {
  return request({
    url: '/admin/ongoing-services',
    method: 'GET'
  })
}

/**
 * 获取用户正在进行的服务
 */
export const getUserRechargeRecords = (page, limit, keyword) => {
  return request({
    url: '/admin/recharge-records',
    method: 'GET',
    params: { page, limit, keyword }
  })
}

/**
 * 获取 AI 简历优化充值记录
 */
export const getResumeOptimizeRechargeRecords = (
  page,
  limit,
  keyword,
  channel,
  planId
) => {
  return request({
    url: '/admin/resume-optimize-recharge-records',
    method: 'GET',
    params: { page, limit, keyword, channel, planId }
  })
}

/**
 * 获取总收入统计和充值记录
 */
export const getIncomeRecords = (params) => {
  return request({
    url: '/admin/income-records',
    method: 'GET',
    params
  })
}

/**
 * 旺旺币兑换的服务
 */
export const getUserWwcoinExchangeRecords = (page, limit, keyword) => {
  return request({
    url: '/admin/wwcoin-exchange-records',
    method: 'GET',
    params: { page, limit, keyword }
  })
}

/**
 * 后台人工调整用户权益
 */
export const updateUserBenefits = (userId, data) => {
  return request({
    url: `/admin/user/${userId}/benefits`,
    method: 'PATCH',
    data
  })
}

/**
 * 获取用户权益人工调整记录
 */
export const getUserBenefitAdjustments = (userId, page, limit) => {
  return request({
    url: `/admin/user/${userId}/benefit-adjustments`,
    method: 'GET',
    params: { page, limit }
  })
}
